import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const BecomeAffiliate = lazy(() => import("@/pages/BecomeAffiliate"));

export const Route = createFileRoute("/_public/become-affiliate")({
  component: BecomeAffiliate,
});
